import {flipApi} from 'yxt-biz-pc/packages/api';

/**
 * 获取面授考勤请假审核信息
 * @param {String} formId
 * @returns
 */
export const getLeaveAuditInfo = formId => flipApi.get(`flip/audit/leave-info/${formId}`);
